var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEarth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "global",
    width: 22.323,
    height: 22.323,
    viewBox: "0 0 22.323 22.323",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:#1f3f93}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    transform: "translate(15.949 6.015)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M370.917 137.952l-.073.032a23.891 23.891 0 0 1-5.049 1.6 17.048 17.048 0 0 1 0 7.044 23.831 23.831 0 0 1 5.051 1.588l.071.032a11.206 11.206 0 0 0 0-10.292z",
    className: "cls-1",
    transform: "translate(-365.792 -137.952)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    transform: "translate(8.114 15.634)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M186.112 358.772a15.509 15.509 0 0 0 3.046 5.466 15.488 15.488 0 0 0 3.046-5.466 23.246 23.246 0 0 0-6.092 0z",
    className: "cls-1",
    transform: "translate(-186.112 -358.572)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    transform: "translate(7.401 7.861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    d: "M176.912 180.288a22.036 22.036 0 0 1-6.816 0 15.633 15.633 0 0 0 0 6.613 24.74 24.74 0 0 1 6.81 0 15.612 15.612 0 0 0 .006-6.613z",
    className: "cls-1",
    transform: "translate(-169.744 -180.288)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    transform: "translate(8.114 1.023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    d: "M189.158 23.456a15.5 15.5 0 0 0-3.046 5.468 23.307 23.307 0 0 0 6.091 0 15.515 15.515 0 0 0-3.045-5.468z",
    className: "cls-1",
    transform: "translate(-186.112 -23.456)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    transform: "translate(12.123)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    d: "M278.048 0a16.921 16.921 0 0 1 3.482 6.273 22.361 22.361 0 0 0 4.741-1.473 11.137 11.137 0 0 0-8.223-4.8z",
    className: "cls-1",
    transform: "translate(-278.048)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    transform: "translate(1.976)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    d: "M45.312 4.8a22.492 22.492 0 0 0 4.741 1.473A16.921 16.921 0 0 1 53.535 0a11.139 11.139 0 0 0-8.223 4.8z",
    className: "cls-1",
    transform: "translate(-45.312)"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    transform: "translate(0 6.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    d: "M6.372 139.612a23.923 23.923 0 0 1-5.046-1.6l-.073-.032a11.2 11.2 0 0 0 0 10.292l.073-.032a23.636 23.636 0 0 1 5.049-1.588 17.025 17.025 0 0 1-.003-7.04z",
    className: "cls-1",
    transform: "translate(0 -137.984)"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    transform: "translate(1.976 16.052)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    d: "M50.053 368.16a22.358 22.358 0 0 0-4.741 1.472 11.14 11.14 0 0 0 8.223 4.8 16.927 16.927 0 0 1-3.482-6.272z",
    className: "cls-1",
    transform: "translate(-45.312 -368.16)"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    transform: "translate(12.123 16.05)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    d: "M281.53 368.128a16.9 16.9 0 0 1-3.482 6.273 11.137 11.137 0 0 0 8.223-4.8 22.362 22.362 0 0 0-4.741-1.473z",
    className: "cls-1",
    transform: "translate(-278.048 -368.128)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarth);
export default __webpack_public_path__ + "static/media/earth.993c197a1a1235419d7abcc345479c41.svg";
export { ForwardRef as ReactComponent };